var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hide-content"},[_c('img',{attrs:{"src":require("@/assets/images/my-quiz-answer/empty-answers.svg")}}),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('review_all_questions'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }